import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SessionService } from './session.service';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { firstValueFrom, filter, timeout, catchError, of } from 'rxjs';

export const RoleGuard: CanActivateFn = async (route, state) => {
  const sessionService = inject(SessionService);
  const msalBroadcastService = inject(MsalBroadcastService);
  const router = inject(Router);

  await firstValueFrom(
    msalBroadcastService.inProgress$.pipe(
      filter(status => status === InteractionStatus.None),
      timeout(10000),
      catchError(() => of(InteractionStatus.None))
    )
  );

  await sessionService.updateLoginState();

  if (!sessionService.isLoggedIn) {
    await sessionService.login(state.url);
    return false;
  }

  const userRoles = sessionService.getRoles;
  const allowedRoles: string[] = route.data['roles'] ?? [];
  const hasAccess = userRoles.some(role => allowedRoles.includes(role));

  if (hasAccess) {
    return true;
  }

  return router.createUrlTree(['/access-denied'], {
    queryParams: { returnUrl: state.url },
  });
};
